<section class="placeholder-hero">
  <div class="container">
    <p class="eyebrow eyebrow--light">PlateX valuation</p>
    <h1 class="display display--light">
      Generating your valuation for
      <span class="reg-out">{{ registration || 'your plate' }}</span>
      &hellip;
    </h1>
    <p class="lede lede--light">
      Your valuation is being prepared. We&rsquo;ll have a clear, comparables-led
      result for you shortly &mdash; including likely demand and the routes
      best suited to your plate.
    </p>

    <div class="pulse-block" role="status" aria-live="polite">
      <span class="pulse-dot" aria-hidden="true"></span>
      <span class="pulse-text">Working&hellip;</span>
    </div>

    <p class="fineprint">
      No commitment, no charge. Hold tight while we run the comparables.
    </p>
  </div>
</section>
